/**
 * Touch tablets narrower than the `desktop` breakpoint (iPad Pro, iPad Air in
 * landscape, large Android tablets) get the same layout as a small iPad, so the
 * booking flow keeps its compact progress bar, stacked steppers and single-column
 * tiles. Laptops at the same widths have a mouse or trackpad and keep the
 * desktop layout.
 *
 * Keep in sync with `minWidthExceptTouchTablet` in tailwind.config.js and the
 * touch-tablet media queries in App.css.
 */
export const TOUCH_TABLET_QUERY = "(hover: none) and (pointer: coarse) and (max-width: 1379px)";

const SMALL_TABLET_LAYOUT_WIDTH = 768;

/**
 * The width to make layout breakpoint decisions with: the real viewport width,
 * except on touch tablets where it is capped at the small-iPad width.
 * Use `window.innerWidth` directly for positioning maths, never this.
 */
export function getLayoutWidth(): number {
  const width = window.innerWidth;
  const isTouchTablet = typeof window.matchMedia === "function" && window.matchMedia(TOUCH_TABLET_QUERY).matches;
  return isTouchTablet ? Math.min(width, SMALL_TABLET_LAYOUT_WIDTH) : width;
}
